import { DocumentFile } from './document-file';

export enum DataRecordSource {
  UploadedDocument = 'UPLOADED_DOCUMENT',
  VendorData = 'VENDOR_DATA',
}

export enum VendorDataClassification {
  Original = 'Original',
  Reclassified = 'Reclassified',
  Restated = 'Restated',
}

export class VendorDataRecord extends DocumentFile {
  source: DataRecordSource;
  reportingInterval: string;
  isReclassified: boolean;
  classification: VendorDataClassification;
  isSuperseded: boolean;
  supersededBy: number;
}
